import React from 'react';
import { ReloadOutlined } from '@ant-design/icons';

const STEP_BUTTON_CLASS = "h-[36px] rounded-[8px] bg-white text-[23px] font-bold text-[#17345b] shadow-sm hover:bg-[#f4f7fb] disabled:cursor-not-allowed disabled:opacity-50";

interface KioskCountPanelFormProps {
  // 앞에 "☼"는 컴포넌트가 붙인다.
  title: string;
  name: string;
  value: number;
  onChange: (name: string, newValue: number) => void | Promise<void>;
  onReset: () => void | Promise<void>;
  resetTitle: string;
  // +, −, 초기화 버튼을 모두 비활성화한다. 예: 초기화 처리 중
  isDisabled?: boolean;
  // 바깥 여백. 넘기면 기본값 전체를 대체한다.
  wrapperStyle?: string;
}

export const KioskCountPanelForm: React.FC<KioskCountPanelFormProps> = ({
  title,
  name,
  value,
  onChange,
  onReset,
  resetTitle,
  isDisabled = false,
  wrapperStyle = "mb-[10px]",
}) => {
  return (
    <div className={`${wrapperStyle} relative flex min-h-[94px] w-full items-center rounded-[12px] bg-gradient-to-b from-[#ffd83e] to-[#ffb400] px-[12px] py-[8px] shadow-sm`}>
      <span className="absolute left-[14px] top-[10px] text-[14px] font-bold text-[#3a3100]">
        ☼ {title}
      </span>
      <strong className="flex-1 pt-[14px] text-center text-[50px] leading-none text-[#221d00]">
        {Number(value).toLocaleString('en-US')}
      </strong>
      <div className="flex w-[150px] flex-col gap-[5px]">
        <div className="grid grid-cols-2 gap-[5px]">
          <button
            type="button"
            className={STEP_BUTTON_CLASS}
            disabled={isDisabled}
            onClick={() => void onChange(name, value + 1)}
          >
            +
          </button>
          <button
            type="button"
            className={STEP_BUTTON_CLASS}
            disabled={value <= 0 || isDisabled}
            onClick={() => void onChange(name, Math.max(0, value - 1))}
          >
            −
          </button>
        </div>
        <button
          type="button"
          className="flex h-[36px] items-center justify-center gap-[6px] rounded-[8px] bg-[#17345b] text-[14px] font-bold text-white shadow-sm hover:bg-[#102846] disabled:cursor-not-allowed disabled:opacity-50"
          disabled={isDisabled}
          onClick={() => void onReset()}
        >
          <ReloadOutlined />
          {resetTitle}
        </button>
      </div>
    </div>
  );
};
